import { SkeletonText, SkeletonTextLine, VisuallyHidden } from "@vp/swan";
import React from "react";
import { useLocalization } from "../hooks/useLocalizations";

const PriceLoading = () => {
    const { t } = useLocalization();
  return (
    <SkeletonText>
      <VisuallyHidden>{t("price-platform.skeleton-text")}</VisuallyHidden>
      <SkeletonTextLine width="narrow"></SkeletonTextLine>
    </SkeletonText>
  );
};

export default PriceLoading;
